import { AlertCircle } from "lucide-react";
import React, { forwardRef } from "react";

interface TextInputCompProps {
    type?: string;
    placeholder?: string;
    className?: string;
    onChangeText: (text: string) => void;
    value: string | number;
    showLabel?: boolean;
    label?: string;
    maxLength?: number;
    error?: string | null;
    min?: number;
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
    disabled?: boolean;
    showStar?: boolean;
}

const TextInputComp = forwardRef<HTMLInputElement, TextInputCompProps>(
    (
        {
            type,
            placeholder,
            className = "",
            onChangeText,
            value,
            showLabel = false,
            label,
            maxLength,
            min,
            onKeyDown,
            error = null,
            disabled,
            showStar,
        },
        ref
    ) => {
        const hasError = !!error;

        return (
            <div className="py-2">
                {showLabel && (
                    <label className="pb-2 block flex items-center gap-1">
                        <p className="text-md text-mainBrandColor">
                            {label}
                        </p>

                        {showStar && (
                            <p className="text-sm text-red-500">*</p>
                        )}
                    </label>
                )}

                <div className="relative">
                    <input
                        ref={ref}
                        type={type}
                        placeholder={placeholder}
                        value={value}
                        className={`
                            w-full
                            p-2
                            rounded-lg
                            text-base
                            md:text-sm
                            text-logoHeading
                            border
                            border-gray-400
                            hover:border-accent
                            focus:outline-none
                            focus:border-accent
                            focus:ring-1
                            focus:ring-accent
                            placeholder:text-base
                            md:placeholder:text-sm
                            ${className}
                            ${
                                disabled
                                    ? "opacity-70 cursor-not-allowed bg-gray-200 text-gray-900"
                                    : "bg-white cursor-pointer"
                            }
                            ${
                                hasError
                                    ? "border-red-500 focus:border-red-500 focus:ring-red-500"
                                    : ""
                            }
                        `}
                        onChange={(e) =>
                            onChangeText(e.target.value)
                        }
                        maxLength={maxLength}
                        min={min}
                        onKeyDown={onKeyDown}
                        disabled={disabled}
                    />

                    {hasError && (
                        <AlertCircle
                            size={18}
                            className="absolute right-3 top-1/2 -translate-y-1/2 text-red-500"
                        />
                    )}
                </div>
            </div>
        );
    }
);

export default TextInputComp;